import { useLocation } from "react-router-dom";
import NotificationButton from "../components/notification/NotificationButton";
import DarkModeButton from "../components/common/dark_mode/DarkModeButton";
import Dropdown from "react-bootstrap/Dropdown";
import { DropDownToggleButton } from "../components/common/button/DropDownToggleButton";
import ProfileActions from "./ProfileActions";
import ProfileWidget from "./ProfileWidget";
import useModules from "../hooks/services/profile/useModules";

const NavBar = () => {
  const location = useLocation();
  const { getModuleByPath } = useModules();

  return (
    <div className="header-dashboard">
      <div className="title-dashboard">
        {/* get the name of the component based on current link*/}
        <span>{getModuleByPath(location.pathname)?.name}</span>
      </div>
      <div className="right-header-dashboard">
        {/* toggle dark mode button for desktop */}
        <DarkModeButton />

        {/* notification button for dekstop */}
        <NotificationButton />
        <div className="bloc-profile-header">
          <Dropdown className="profile-menu-header">
            <Dropdown.Toggle as={DropDownToggleButton}>
              <ProfileWidget />
              <i className="fas fa-chevron-down" />
            </Dropdown.Toggle>
            <ProfileActions show={false} />
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
